<template>
<div>
 	<div class="row">
        <div class="col-md-12 col-12">
            <h4 class="def-title">Guia de Ajuda</h4>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col">
            <v-button v-if="showGuia" :link="true" label="Não exibir este guia na entrada do sistema" @click="apiPost"></v-button>
            <p v-if="showMensagem">Este guia não será mais exibido na abertura do sistema. Para acessá-lo, vá ao menu de ajuda!</p>
        </div>
    </div>

    <!-- <div class="default-container">
        <div class="row p-5">
            <div class="col-12 col-md-offset-1 col-md-10">
                <div class="m-top">
                    <h2>Bem vindo ao Loja Nota Brasil!</h2>
                    <h4>Siga o roteiro que preparamos para você:</h4>
                </div>
            </div>
            <div class="d-flex flex-wrap mt-3">
                <a href="" class="onboarding-btn onboarding-btn-done card m-right p-all m-bottom-xs" data-event="galileo_onboarding_select_theme_click" data-state="done">
                    <i class="fa fa-paint-brush fa-w-16 m-top-quarter fa-2x" aria-hidden="true" role="img"></i>
                    <i class="fa fa-check-circle fa-w-16 onboarding-btn-done-icon fa-2x" aria-hidden="true" data-prefix="fal" data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""></i>
                    <p class="m-top-half">Configuração da Loja</p>
                </a>
                <a href="" class="onboarding-btn onboarding-btn-done card m-right p-all m-bottom-xs" data-event="galileo_onboarding_select_theme_click" data-state="done">
                    <i class="fa fa-paint-brush fa-w-16 m-top-quarter fa-2x" aria-hidden="true" role="img"></i>
                    <i class="fa fa-check-circle fa-w-16 onboarding-btn-done-icon fa-2x" aria-hidden="true" data-prefix="fal" data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""></i>
                    <p class="m-top-half">Cadastrar Produtos</p>
                </a>
                <a href="" class="onboarding-btn onboarding-btn-done card m-right p-all m-bottom-xs" data-event="galileo_onboarding_select_theme_click" data-state="done">
                    <i class="fa fa-paint-brush fa-w-16 m-top-quarter fa-2x" aria-hidden="true" role="img"></i>
                    <i class="fa fa-check-circle fa-w-16 onboarding-btn-done-icon fa-2x" aria-hidden="true" data-prefix="fal" data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""></i>
                    <p class="m-top-half">Definir Preços</p>
                </a>
            </div>        
        </div>
    </div> -->

    <div class="default-container px-5">
        <div class="p-3">
            <div class="row">
                <div class="col-12">
                    <ul class="timeline">
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Visão Geral</h6>
                            <p>Apresentação do funcionamento da loja virtual</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.visao.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Configurações Iniciais</h6>
                            <p>Veja como configurar os dados da loja e sua a aparência</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.config.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Importar Produtos e Preços</h6>
                            <p>Veja como importar o cadastro de produtos e preços</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.importar.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Categorias de Produtos</h6>
                            <p>Veja como determinar as categorias de produtos</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.categorias.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Cadastro dos Produtos e Fotos</h6>
                            <p>Veja como funciona o cadastro de produtos e importação de fotos dos produtos</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.produtos.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Preço dos Produtos</h6>
                            <p>Veja como configurar uma tabela de preços para seus produtos</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.precos.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Produtos em Promoção</h6>
                            <p>Veja como configurar produtos em promoção na loja</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.promocao.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Produtos em Destaque</h6>
                            <p>Veja como configurar produtos em destaque na loja</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.destaque.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                        <li>
                            <h6 style="text-transform: uppercase; color: #afaeae">Gerenciar os Pedidos Recebidos</h6>
                            <p>Veja como funciona o gerenciamento dos pedidos recebidos na loja</p>
                            <div class="text-center">
                                <iframe width="560" height="315" :src="videos.pedidos.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSapp } from '../shared/api-functions'

export default {
    props: {
    },

    data() {
        return {
            videos: {
                visao: {
                    url: '',
                    video: '//www.youtube.com/embed/wvl-3cP4LbA',
                },
                config: {
                    url: '',
                    video: '//www.youtube.com/embed/JWNNS9eHIeI',
                },
                importar: {
                    url: '',
                    video: '//www.youtube.com/embed/6Bmo4YZTmII',
                },
                categorias: {
                    url: '',
                    video: '//www.youtube.com/embed/dTzPlrNo97k',
                },
                produtos: {
                    url: '',
                    video: '//www.youtube.com/embed/Q9UtMhZGyiw',
                },
                precos: {
                    url: '',
                    video: '//www.youtube.com/embed/ZqW9c7_BQGE',
                },
                promocao: {
                    url: '',
                    video: '//www.youtube.com/embed/atVVQ1Gp3PM',
                },
                destaque: {
                    url: '',
                    video: '//www.youtube.com/embed/8QyMz3Xloo0',
                },
                pedidos: {
                    url: '',
                    video: '//www.youtube.com/embed/mD52DRPD5Ck',
                },
            },

            showMensagem: false,

        }
    },

    computed: {
        showGuia: function () {
            return SysVars.guia
        }
    },

    watch: {

    },


    methods: {
        async apiPost () {
            const ativacao = await apiORDSapp(this, 'usuario/guia/', 'post', null)
            this.$appLoading(false)
            SysVars.guia = false
            this.showMensagem = true
        },

    },

    components: {

    },

    beforeCreate () {

    },

    mounted () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    created () {
        
    }

}

</script>

<style>

/* .card {
    border-radius: 8px;
    border: 1px solid #e7e6e7;
    background-color: #fff;
    padding: 10px;
}

.card, .dropdown, .dropleft, .dropright, .dropup {
    position: relative;
}

.p-all {
    padding: 20px!important;
}

.m-right {
    margin-right: 20px;
}


.onboarding-btn {
    height: 130px;
    transition: all .2s ease-in-out;
    width: 150px;
}

.onboarding-btn-done, .onboarding-btn-done p, .onboarding-btn-done p:hover {
    color: #bfbbbd;
}

.onboarding-btn-done .onboarding-btn-done-icon {
    color: #00c6a3;
    display: block!important;
    position: absolute;
    right: 20px;
    top: 20px;
}

.onboarding-btn-done, .onboarding-btn-done p, .onboarding-btn-done p:hover {
    color: #bfbbbd;
}

a:active, a:active:focus, a:active:hover, a:focus, a:hover {
    color: #14b9fd;
    text-decoration: none;
}

.onboarding-btn:focus, .onboarding-btn:hover {
    color: #4dbecf;
    cursor: pointer;
    text-decoration: none;
    transform: scale(1.08);
}

.m-top-half {
    margin-top: 10px;
}




.svg-inline--fa, svg:not(:root).svg-inline--fa {
    overflow: visible;
}
svg:not(:root).svg-inline--fa {
    overflow: visible;
}

svg:not(:root) {
    overflow: hidden;
}

.m-top-quarter {
    margin-top: 5px;
}

.fa-2x {
    font-size: 2em;
}

.svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -.125em;
}

.svg-inline--fa {
    font-size: inherit;
    height: 1em;
    vertical-align: -.125em;
}

.svg-inline--fa.fa-w-16 {
    width: 1em;
}

#Grid .gap, #Grid:after, .fa-layers, .fa-stack, .svg-inline--fa, .swiper-slide {
    display: inline-block;
}


svg:not(:root) {
    overflow: hidden;
}

.svg-inline--fa {
    font-size: inherit;
    height: 1em;
    vertical-align: -.125em;
}

#Grid .gap, #Grid:after, .fa-layers, .fa-stack, .svg-inline--fa, .swiper-slide {
    display: inline-block;
}
 */

</style>



// WEBPACK FOOTER //
// src/forms-loja/guia-loja.vue